import { PureComponent } from 'preact-compat'
import { ContentType } from '@insided/shared/utils/contentType'
// eslint-disable-next-line import/no-internal-modules
import { DropdownSelectizeInput } from '@insided/deprecated-preact-components/dropdown/DropdownSelectize'
import { editModeratorTags } from '@insided/shared/services/topicService'

interface ModeratorTagsProps {
  onModeratorTagsChanged: (newModeratorTags: string[]) => void
  setIsLoading: (isLoading: boolean) => void
  moderatorTags: string[]
  contentType: ContentType
  privateId: number
}

class ModeratorTags extends PureComponent<ModeratorTagsProps> {
  constructor (props: ModeratorTagsProps) {
    super(props)
    this.onChangeModeratorTags = this.onChangeModeratorTags.bind(this)
  }

  async onChangeModeratorTags (newModeratorTags: string[]) {
    const { contentType, privateId, onModeratorTagsChanged, setIsLoading } = this.props
    setIsLoading(true)
    try {
      await editModeratorTags(contentType, privateId, newModeratorTags)
      onModeratorTagsChanged(newModeratorTags)
    } finally {
      setIsLoading(false)
    }
  }

  render () {
    const { moderatorTags } = this.props
    return (
      <div className='topic-info__details-item'>
        <label>Moderator tags</label>
        <DropdownSelectizeInput
          items={[]}
          single={false}
          // eslint-disable-next-line @gorazdo/preact/prefer-classname
          class='form-control qa-topic-creator-moderator-tags-input'
          placeholder='Moderator tags'
          selectedItems={moderatorTags?.length ? moderatorTags : []}
          onChange={this.onChangeModeratorTags}
        />
      </div>
    )
  }
}

export default ModeratorTags
